import { accessService } from '@shared/api';

import type { Permission } from '../model/types';

export type GetMyPermissionsResponse = Permission[];

export const getMyPermissions = () =>
  accessService
    .get<GetMyPermissionsResponse>('/permissions/my')
    .then((response) => response.data);
